import React, { Fragment } from "react";
import { Typography } from "@mui/material";
import { Outlet } from "react-router-dom";

function WorkSite() {
    return <><Outlet /></>;
}
export default WorkSite;